import React from "react";

import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Paymentmethod from "../Pages/Paymentmethod/Paymentmethod";

import Latestupdate from "../Component/Latestupdate/Latestupdate";

export default function Paymentmethodtheme() {
  return (
    <>
      <Header />
      <Paymentmethod />
      <Latestupdate />
      <Footer />
    </>
  );
}
